import {GameData} from './GameData';

export enum GameStateType {
  NORMAL = 'normal',
  BACKUP = 'backup',
}

export enum GameStateStatus {
  PLAYING = 'PLAYING',
  FAILED = 'FAILED',
  SUCCEED = 'SUCCEED',
}

export interface GameState {
  idApi?: string;
  userId: string;
  lastUpdate: string; // ISO date string
  lastSync: string; // ISO date string
  uniqueURI: string;
  slot: number;
  data: GameData;
  dirty: boolean;
  type: GameStateType;
  state: GameStateStatus;
  hasBackup: boolean;
}

export const createGameState = (
  uniqueURI: string,
  slot: number,
  data: GameData,
  userId: string,
): GameState => {
  const now = new Date().toISOString();
  return {
    userId,
    lastUpdate: now,
    lastSync: now,
    uniqueURI,
    slot,
    data,
    dirty: true,
    type: GameStateType.NORMAL,
    state: GameStateStatus.PLAYING,
    hasBackup: false,
  };
};
